import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import Form from 'rc-field-form'
import { FormItem } from 'components'
import { Input, LoginButton } from 'app/mobile/components'
import styles from './index.module.less'

const selector = ({ login, loading }) => ({
  limit: login.limit,
  loading: ['login/onGeetest', 'login/login'].some(
    item => loading.effects[item]
  ),
})
export default function Index() {
  const dispatch = useDispatch()
  const { limit, loading } = useSelector(selector, shallowEqual)
  const [loginBut, setLoginBut] = useState(false)

  const history = useHistory()
  const [form] = Form.useForm()

  const onValuesChange = () => {
    const values = form.getFieldsValue()
    setLoginBut(values?.workId && values?.password)
  }

  const __dev__ = process.env.NODE_ENV === 'development'
  const initialValues = {
    workId: __dev__ ? 'YGADMIN' : '',
    password: __dev__ ? 'qwert123456' : '',
  }

  const onFinish = values => {
    dispatch({
      type: 'login/login',
      payload: {
        ...values,
        limit,
        loginType: 'id',
        history,
      },
    })
  }

  return (
    <>
      <Form
        form={form}
        initialValues={initialValues}
        onFinish={onFinish}
        onValuesChange={onValuesChange}>
        <FormItem
          name="workId"
          rules={[{ required: true, message: '请输入工号' }]}>
          <Input placeholder="请输入工号" trim={true} />
        </FormItem>
        <FormItem
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}>
          <Input placeholder="请输入密码" type="password" />
        </FormItem>
        <div className={styles.forget}>
          <span onClick={() => history.push('/mobile/reset-password')}>
            忘记密码？
          </span>
        </div>
        <LoginButton disabled={!loginBut} loading={loading} />
      </Form>
    </>
  )
}
